export default "__VITE_ASSET__CRU59UPG__"